import api from '../../../Libs/Services/api'

/** Communication (birleşik mesajlaşma) — ticket/reservation/product. */
const CommunicationService = {
    list: (data) => api.post('Communication/list', data),
    thread: (data) => api.post('Communication/thread', data),
    send: (data) => api.post('Communication/send', data),
    unread: (data) => api.post('Communication/unread', data),
    archive: (data) => api.post('Communication/archive', data),
    openReservation: (data) => api.post('Communication/openReservation', data),
    openProduct: (data) => api.post('Communication/openProduct', data),
    createTicket: (data) => api.post('Communication/createTicket', data),
    upload: (formData) => api.post('Communication/upload', formData),
}

export default CommunicationService
